import { ldb, state } from '@codesuma/baseline'

// Native only: tells the user when their store holds a newer version. The web
// app has its own bar for this, raised by the service worker (public/init.js).
//
// The store itself is asked — Google Play's in-app update API on Android,
// Apple's public lookup on iOS, both through @capawesome/capacitor-app-update —
// so the notice appears once a release is live there, with no file of ours to
// keep in step with it.

const LATER_KEY = 'app-update-later' // epoch ms until which the notice stays away
const LATER_MS = 7 * 24 * 60 * 60 * 1000
const APP_STORE_ID = '6792455885' // iOS needs it to open the page; Play finds the app itself
const UPDATE_AVAILABLE = 2 // AppUpdateAvailability.UPDATE_AVAILABLE

const plugin = () => (window as any).Capacitor?.Plugins?.AppUpdate

async function check() {
    // Empty and not a number when never set: ldb answers a missing key with ''.
    if (Date.now() < Number(ldb.get(LATER_KEY))) return
    try {
        const info = await plugin().getAppUpdateInfo()
        if (info.updateAvailability === UPDATE_AVAILABLE) state.set('app-update', true)
    } catch {
        // Offline, no Play services, or a build no store installed (a debug
        // build): say nothing, and ask again on the next launch.
    }
}

export default {
    init() {
        if (!plugin()) return // web, where the service worker does this
        check()
    },
    open() {
        plugin()?.openAppStore({ appId: APP_STORE_ID })
    },
    later() {
        ldb.set(LATER_KEY, Date.now() + LATER_MS)
        state.set('app-update', false)
    },
}
